import {ShapeCommand} from '../commands.template';
import * as _ from 'lodash';

export class ActivityAddRequirementsCommand extends ShapeCommand {
  services: any;
  firstAction: boolean;
  mxKey;
  constructor(data) {
    super(data);
    this.mxKey = 0;
    this.firstAction = true;
  }

  public execute() {
    const mxKey = this.getMxKey(this.object.itemMxKey);
    const param = this.getRequirementInterface(this.object.items, mxKey, false);

    this.mxKey = _.map(param, item => +item.mxKey);
    const action = {createRequirementAttachment: param};

    return this.services.diagramUpdateSvc.update(action, true, true).then(result => {
      const requirementAttachmentObject = this.getRequirementInterface(
        this.object.items,
        mxKey,
        true
      );

      this.services.jsonHandlerSvc.update({
        createRequirementAttachment: requirementAttachmentObject
      });
      this.redrawActivity(this.object.itemMxKey);

      return result;
    });
  }

  public reverse() {
    const action = {
      deleteRequirementAttachment: {
        itemMxKey: this.object.itemMxKey, // activity mxKek
        mxKey: this.mxKey // attachments mxKey
      }
    };

    return this.services.diagramUpdateSvc.update(action, true, true).then(result => {
      this.services.jsonHandlerSvc.update(action);
      this.redrawActivity(this.object.itemMxKey);

      return result;
    });
  }

  private getMxKey(itemMxKey) {
    const diagramJson = this.services.jsonHandlerSvc.get();

    const activity = _.find(diagramJson.activities, act => +act.mxKey === +itemMxKey);

    if (!activity.requirementAttachments) {
      activity.requirementAttachments = [];
    }

    let mxKey = 0;

    activity.requirementAttachments.forEach(function (attachment) {
      if (attachment.mxKey > mxKey) {
        mxKey = attachment.mxKey;
      }
    });

    return mxKey + 1;
  }

  private redrawActivity(mxKey) {
    this.services.editorRegistrySvc
      .getGraph()
      .model.getCell(Number(mxKey))
      .comp.instance.setupFromJson();
  }

  private getRequirementInterface(data, mxKey, populateRequirement: boolean) {
    let key = Number(mxKey);

    return _.map(this.object.items, el => {
      return {
        mxKey: key++,
        itemMxKey: el.itemMxKey,
        type: 'requirement',
        reqId: el.reqId,
        requirement: populateRequirement
          ? {
              id: el.id,
              status: el.status
            }
          : el.id,
        title: el.summary.substring(60, 0),
        description: '',
        groups: el.groups,
        reqReason: el.reqReason,
        reqDetails: el.reqDetails
      };
    });
  }
}
